import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Stack from '@mui/material/Stack';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ListItemIcon from '@mui/material/ListItemIcon';
import Tooltip from '@material-ui/core/Tooltip';

class SpatialFilterList extends Component {

    constructor(props) {
        super(props);
        this.state =
        {
            optionsMenuIsOpen: false
        };
    }

    handleMenuClose = () => {
        this.setState({
            optionsMenuIsOpen: false
        });
    }

    deleteFilter = () => {
        const item = this.props.spatialFilters[this.state.idx];
        window.api.deleteSpatialFilter(item.attributes.OBJECTID).then(response => {
            this.props.setSpatialFilters(response);
        });
    }

    listItemClicked = (idx) => {
        const item = this.props.spatialFilters[idx];
        //const geometry = JSON.parse();

        this.props.onSpatialFilterClicked(item);
    }

    renameFilter = () => {
        //const item = this.props.spatialFilters[this.state.idx];
        //window.api.deleteCustomFilter(item.CustomFilterID).then(response => {
        // this.props.setCustomFilters(response);
        //});
    }

    render() {
        return (<Fragment>
            <Table size="small">
                <TableBody>
                    {
                        this.props.spatialFilters.map((item, idx) => {
                            //const filterContent = JSON.parse(item.FilterContent);
                            //const showHighlighted = (this.props.user.activeCustomFilterState && (filterContent.filterGuid === this.props.user.activeCustomFilterState.filterGuid));
                            return (
                                <TableRow key={idx}>
                                    <TableCell>
                                        <Button
                                            color="primary"
                                            variant="text"
                                            onClick={e => {
                                                this.listItemClicked(idx);
                                                this.setState({
                                                    idx: idx
                                                });
                                            }}>{item.attributes.Filtername}</Button>
                                    </TableCell>

                                    <TableCell align="right">
                                        <Tooltip title="Options" placement="top-start">
                                            <IconButton
                                                aria-label="close"
                                                color="inherit"
                                                size="small" onClick={(e) => {
                                                    this.setState({
                                                        optionsMenuIsOpen: true,
                                                        anchorEl: e.currentTarget,
                                                        idx: idx
                                                    });

                                                }}>
                                                <MoreVertIcon
                                                    className="filter-item-header-clear"
                                                    style={{ width: "20px", height: "20px", paddingTop: "8px" }} />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
            <Menu open={this.state.optionsMenuIsOpen} anchorEl={this.state.anchorEl} onClose={this.handleMenuClose} style={{ zIndex: "2000" }}>
                <Stack direction="column"> 
                <MenuItem onClick={(e) => {
                    this.renameFilter();
                    this.setState({
                        optionsMenuIsOpen: false
                    });
                }}>
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    Rename
                </MenuItem>
                <MenuItem onClick={(e) => {
                    this.deleteFilter();
                    this.setState({
                        optionsMenuIsOpen: false
                    });
                }}>
                    <ListItemIcon>
                        <DeleteIcon fontSize="small" />
                    </ListItemIcon>
                    Delete
                </MenuItem>
                </Stack>
            </Menu>
        </Fragment>)
    }
}

export default SpatialFilterList;
